import React from 'react';
import { Card } from 'primereact/card';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useGetWarrantyDashboardQuery } from '../../../api/endpoints/warrantyDashboard';
import { ProgressSpinner } from 'primereact/progressspinner';

const PRIMARY = '#273A81';

const WarrantyDashboard = () => {
    const { th } = useLanguage();
    const { data, isLoading, isError, error } = useGetWarrantyDashboardQuery();

    if (isLoading) {
        return (
            <div className="flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                <ProgressSpinner />
            </div>
        );
    }

    if (isError) {
        return (
            <div style={{ border: '1px solid #D9DDE5' }} className="p-4 border-round">
                <h1 style={{ color: PRIMARY }}>{th('warrantyDashboard.title')}</h1>
                <p className="mt-3" style={{ color: PRIMARY }}>
                    {th('common.error')}: {error?.data?.message || th('common.unknownError')}
                </p>
            </div>
        );
    }

    const dashboardData = data?.data || {};

    const warrantyRequests = {
        draft: dashboardData.warrantyClaims?.draftCount || 0,
        new: dashboardData.warrantyClaims?.newlyAddedCount || 0,
        returned: dashboardData.warrantyClaims?.returnedCount || 0,
        karsanReturned: dashboardData.warrantyClaims?.karsanReturnedCount || 0

    };

    const workOrders = {
        open: dashboardData.customerStatements?.openWorkOrderCount || 0,
        closed: dashboardData.customerStatements?.closedWorkOrderCount || 0
    };

    const preApprovals = {
        new: dashboardData.preApprovals?.newRequestCount || 0,
        returned: dashboardData.preApprovals?.returnedCount || 0
    };

    // KÜÇÜK VE KOMPAKT KART TASARIMI
    const StatCard = ({ title, value, icon, showDivider = true }) => (
        <>
            <div className="p-3">
                <div className="flex align-items-center gap-2">
                    <i className={`pi ${icon}`} style={{ fontSize: '1.2rem', color: PRIMARY }} />
                    <div className="flex flex-column">
                        <span style={{ fontSize: '0.75rem', color: '#6B7280' }}>{title}</span>
                        <strong style={{ fontSize: '1.2rem', color: PRIMARY }}>{value}</strong>
                    </div>
                </div>
            </div>
            {showDivider && <div style={{ borderTop: '1px solid #E5E7EB', margin: '0' }} />}
        </>
    );

    const SectionTitle = ({ title }) => (
        <div style={{ margin: 0 }}>
            <h2
                style={{
                    color: '#FFFFFF',
                    fontSize: '1rem',
                    fontWeight: 600,
                    backgroundColor: '#8e8e93',
                    padding: '12px 16px',
                    display: 'block',
                    margin: 0
                }}
            >
                {title}
            </h2>
        </div>
    );

    return (
        <div>
            <h1 className="mb-4" style={{ color: PRIMARY }}>
                {th('warrantyDashboard.title')}
            </h1>

            <div className="grid">
                {/* Garanti Talepleri */}
                <div className="col-12 md:col-4">
                    <Card
                        style={{
                            border: '1px solid #D7DCE7',
                            borderRadius: '6px',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                            overflow: 'hidden'
                        }}
                        pt={{
                            body: { style: { padding: 0 } },
                            content: { style: { padding: 0 } }
                        }}
                    >
                        <SectionTitle title={th('warrantyDashboard.warrantyRequests.title')} />
                        <StatCard title={th('warrantyDashboard.warrantyRequests.draftCount')} value={warrantyRequests.draft} icon="pi-file-edit" />
                        <StatCard title={th('warrantyDashboard.warrantyRequests.newlyAddedCount')} value={warrantyRequests.new} icon="pi-plus-circle" />
                        <StatCard title={th('warrantyDashboard.warrantyRequests.returnedCount')} value={warrantyRequests.returned} icon="pi-arrow-circle-left" />
                        <StatCard title={th('warrantyDashboard.warrantyRequests.karsanReturnedCount')} value={warrantyRequests.karsanReturned} icon="pi-arrow-circle-right" showDivider={false} />
                    </Card>
                </div>

                {/* İş Emri */}
                <div className="col-12 md:col-4">
                    <Card
                        style={{
                            border: '1px solid #D7DCE7',
                            borderRadius: '6px',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                            overflow: 'hidden'
                        }}
                        pt={{
                            body: { style: { padding: 0 } },
                            content: { style: { padding: 0 } }
                        }}
                    >
                        <SectionTitle title={th('warrantyDashboard.workOrders.title')} />
                        <StatCard title={th('warrantyDashboard.workOrders.openCount')} value={workOrders.open} icon="pi-folder-open" />
                        <StatCard title={th('warrantyDashboard.workOrders.closedCount')} value={workOrders.closed} icon="pi-check-circle" showDivider={false} />
                    </Card>
                </div>

                {/* Ön Onay */}
                <div className="col-12 md:col-4">
                    <Card
                        style={{
                            border: '1px solid #D7DCE7',
                            borderRadius: '6px',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                            overflow: 'hidden'
                        }}
                        pt={{
                            body: { style: { padding: 0 } },
                            content: { style: { padding: 0 } }
                        }}
                    >
                        <SectionTitle title={th('warrantyDashboard.preApprovals.title')} />
                        <StatCard title={th('warrantyDashboard.preApprovals.newRequestCount')} value={preApprovals.new} icon="pi-plus-circle" />
                        <StatCard title={th('warrantyDashboard.preApprovals.returnedCount')} value={preApprovals.returned} icon="pi-arrow-circle-left" showDivider={false} />
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default WarrantyDashboard;
